import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { COLOR_MAIN } from "../utils/Colors";
import { useTranslation } from "react-i18next";


export default function Pricing() {
  const { t } = useTranslation();

const tiers = [
  {
    title: t("almost_free"),
    price: "6.99",
    games: 1,
    description: [
      "10 users included",
      "2 GB of storage",
      "Help center access",
      "Email support",
    ],
    buttonText: "Sign up for free",
    buttonVariant: "outlined",
    buttonColor: "primary",
  },
  {
    title: t("professional"),
    subheader: "Recommended",
    games: 2,
    price: "13.29",
    description: [
      "20 users included",
      "10 GB of storage",
      "Help center access",
      "Priority email support",
      "Dedicated team",
      "Best deals",
    ],
    buttonText: "Start now",
    buttonVariant: "contained",
    buttonColor: "secondary",
  },
  {
    title: t("good_deal"),
    price: "31.49",
    games: 5,
    description: [
      "50 users included",
      "30 GB of storage",
      "Help center access",
      "Phone & email support",
    ],
    buttonText: "Contact us",
    buttonVariant: "outlined",
    buttonColor: "primary",
  },
  {
    title: t("great_deal"),
    price: "59.49",
    games: 10,
    description: [
      "50 users included",
      "30 GB of storage",
      "Help center access",
      "Phone & email support",
    ],
    buttonText: "Contact us",
    buttonVariant: "outlined",
    buttonColor: "primary",
  },
];
  return (
    <Container
      id="pricing"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "60%" },
          textAlign: { sm: "left", md: "center" },
        }}
      >
        <Typography
          component="h2"
          variant="h4"
          gutterBottom
          sx={{ color: "text.primary" }}
        >
          {t("pricing")}
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {t("pricing_description")}
        </Typography>
      </Box>
      <Grid
        container
        spacing={3}
        sx={{ alignItems: "center", justifyContent: "center", width: "100%" }}
      >
        {tiers.map((tier) => (
          <Grid
            size={{ xs: 12, sm: tier.title === "Enterprise" ? 12 : 6, md: 4 }}
            key={tier.title}
          >
            <Card
              elevation={4}
              sx={[
                {
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  borderRadius: 4,
                },
                tier.title === "Professional" &&
                  ((theme) => ({
                    border: "none",
                    background: COLOR_MAIN,
                    boxShadow: `0 8px 12px hsla(220, 20%, 42%, 0.2)`,
                  })),
              ]}
            >
              <CardContent>
                <Box
                  sx={[
                    {
                      mb: 1,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 2,
                    },
                    tier.title === "Professional"
                      ? { color: "grey.100" }
                      : { color: "" },
                  ]}
                >
                  <Typography component="h3" variant="h6">
                    {tier.title}
                  </Typography>
                  {/* {tier.title === "Professional" && (
                    <Chip icon={<AutoAwesomeIcon />} label={tier.subheader}/>
                  )} */}
                </Box>
                <Box
                  sx={[
                    {
                      display: "flex",
                      alignItems: "baseline",
                    },
                    tier.title === "Professional"
                      ? { color: "grey.50" }
                      : { color: null },
                  ]}
                >
                  <Typography component="h3" variant="h2">
                    ${tier.price}
                  </Typography>
                </Box>
                <Divider sx={{ my: 2, opacity: 0.8, borderColor: "divider" }} />
                {/* {tier.description.map((line) => ( */}
                <Box
                  sx={{
                    pt: 1,
                    display: "flex",
                    gap: 1.5,
                    alignItems: "center",
                  }}
                >
                  <CheckCircleRoundedIcon
                    sx={[
                      {
                        width: 20,
                        fill:
                          tier.title === "Professional" ? "white" : COLOR_MAIN,
                      },
                      tier.title === "Professional"
                        ? { color: "primary.light" }
                        : { color: "primary.main" },
                    ]}
                  />
                  <Typography
                    variant="body1"
                    component={"span"}
                    sx={[
                      tier.title === "Professional"
                        ? { color: "grey.50" }
                        : { color: null },
                    ]}
                  >
                    {tier.games} {t("games")}
                  </Typography>
                </Box>
                {/* ))}  */}
              </CardContent>
              <CardActions>
                {/* <Button
                  fullWidth
                  variant={tier.buttonVariant as "outlined" | "contained"}
                  color={tier.buttonColor as "primary" | "secondary"}
                  sx={{
                    borderRadius: 12,
                  }}
                >
                  {tier.buttonText}
                </Button> */}
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
